export const APP_ERRORS = {
  PAYMENTS_NOT_CONFIGURED: {
    code: 'PAYMENTS_NOT_CONFIGURED',
    message: 'We are currently unable to process payments. Please try again later.',
    description: 'Payments configuration is missing on the server.'
  },
  INSUFFICIENT_CREDITS: {
    code: 'INSUFFICIENT_CREDITS',
    message: "You've run out of credits. Please buy credits to continue.",
    description: 'User does not have enough free or purchased credits.'
  },
  AUTH_VERIFY_FAILED: {
    code: 'AUTH_VERIFY_FAILED',
    message: 'Authentication failed. Please sign in again.',
    description: 'The provided authentication token is invalid or expired.'
  },
  MISSING_FIREBASE_SERVICE_ACCOUNT: {
    code: 'MISSING_FIREBASE_SERVICE_ACCOUNT',
    message: 'A system configuration error occurred. Please try again later.',
    description: 'Missing Firebase Service Account.'
  },
  MISSING_GEMINI_API_KEY: {
    code: 'MISSING_GEMINI_API_KEY',
    message: 'AI processing is currently unavailable. Please try again later.',
    description: 'The AI processing service is not properly configured.'
  },
  ANALYSIS_FAILED: {
    code: 'ANALYSIS_FAILED',
    message: 'Analysis failed: The model could not generate a valid report. The job description might be unrelated or invalid.',
    description: 'AI model failed to generate report.'
  },
  INVALID_JOB_DESCRIPTION: {
    code: 'INVALID_JOB_DESCRIPTION',
    message: 'The job description provided seems invalid or meaningless. Please provide a real job description.',
    description: 'Job description is too short or gibberish.'
  },
  UNAUTHORIZED: {
    code: 'UNAUTHORIZED',
    message: 'Unauthorized: Please sign in to use this feature.',
    description: 'User must be signed in to perform this action.'
  },
  INVALID_SESSION: {
    code: 'INVALID_SESSION',
    message: 'Unauthorized: Invalid session. Please sign in again.',
    description: 'The session state is invalid or user not found.'
  },
  RESUME_STORE_FULL: {
    code: 'RESUME_STORE_FULL',
    message: 'You can only save up to 10 resumes at a time. Please delete an existing resume to upload a new one.',
    description: 'User reached the maximum limit of 10 stored resumes.'
  },
  OUTPUT_STORE_FULL: {
    code: 'OUTPUT_STORE_FULL',
    message: 'Maximum of 20 saved items reached. Please delete an older item before saving a new one.',
    description: 'User reached the maximum limit of 20 generated outputs.'
  },
  AI_SEARCH_INVALID_JD: {
    code: 'AI_SEARCH_INVALID_JD',
    message: 'AI Search did not return a valid job description.',
    description: 'The AI failed to extract job details from the provided text or URL.'
  },
  URL_FETCH_FAILED: {
    code: 'URL_FETCH_FAILED',
    message: 'The system could not read the provided job URL. Please manually copy and paste the job description text.',
    description: 'All scraping fallback methods failed to retrieve the URL content.'
  },
  COVER_LETTER_FAILED: {
    code: 'COVER_LETTER_FAILED',
    message: 'Cover letter generation failed or produced a very short result. Ensure the job description provided is meaningful.',
    description: 'Cover letter generation was unsuccessful or invalid.'
  },
  UNKNOWN_ERROR: {
    code: 'UNKNOWN_ERROR',
    message: 'An unexpected error occurred. Please try again later.',
    description: 'Fallback error message.'
  }
} as const;

export type AppErrorCode = keyof typeof APP_ERRORS;
